"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldDatepickerSharedInputs = exports.EmeraldDatepickerCoreInputs = exports.EmeraldHourFormat = exports.EmeraldViewType = void 0;
const datepicker_mode_1 = require("./datepicker.mode");
var EmeraldViewType;
(function (EmeraldViewType) {
    EmeraldViewType["date"] = "date";
    EmeraldViewType["month"] = "month";
    EmeraldViewType["year"] = "year";
})(EmeraldViewType || (exports.EmeraldViewType = EmeraldViewType = {}));
var EmeraldHourFormat;
(function (EmeraldHourFormat) {
    EmeraldHourFormat["h_12"] = "12";
    EmeraldHourFormat["h_24"] = "24";
})(EmeraldHourFormat || (exports.EmeraldHourFormat = EmeraldHourFormat = {}));
class EmeraldDatepickerCoreInputs {
    constructor() {
        this.id = `datepicker-id${Math.random()}`;
        this.name = 'datepicker-input';
        this.disabled = false;
        this.visible = false;
        this.className = '';
        this.inline = false;
        this.inputId = `datepicker-input${Math.random()}`;
        this.inputClassName = '';
        this.isFilledContainer = false;
        this.outlined = false;
        this.required = false;
        this.readOnly = false;
        this.keepInvalid = false;
        this.mask = '';
        this.showIcon = false;
        this.icon = 'pi pi-calendar';
        this.showOnFocus = true;
        this.numberOfMonths = 1;
        this.view = 'date';
        this.touchUI = false;
        this.showTime = false;
        this.timeOnly = false;
        this.showSeconds = false;
        this.showMillisec = false;
        this.hourFormat = '12';
        this.locale = '';
        this.stepHour = 1;
        this.stepMinute = 1;
        this.stepSecond = 1;
        this.stepMillisec = 1;
        this.shortYearCutoff = '+10';
        this.hideOnDateTimeSelect = false;
        this.showWeek = false;
        this.dateFormat = 'mm/dd/yy';
        this.showMinMaxRange = false;
        this.showOtherMonths = false;
        this.selectOtherMonths = false;
        this.showButtonBar = false;
        this.todayButtonClassName = 'p-secondary-button';
        this.clearButtonClassName = 'p-secondary-button';
        this.baseZIndex = 0;
        this.autoZIndex = true;
        this.selectionMode = datepicker_mode_1.EmeraldDatepickerMode.Single;
    }
}
exports.EmeraldDatepickerCoreInputs = EmeraldDatepickerCoreInputs;
class EmeraldDatepickerSharedInputs {
    constructor() {
        this.selectionMode = datepicker_mode_1.EmeraldDatepickerMode.Single;
        this.dateFormat = 'mm/dd/yy';
    }
}
exports.EmeraldDatepickerSharedInputs = EmeraldDatepickerSharedInputs;
//# sourceMappingURL=datepicker.inputs.js.map